import { useMemo } from "react";
import { useNotices } from "./useNotices";
import {
  getDriveFolderNamesForAudience,
  resolveNoticeAudienceKey,
} from "../utils/driveFolder";

export function useDriveFolderPickerOptions(
  audience: string | undefined,
  targetSubcircle?: string,
): string[] {
  const { data: notices } = useNotices();

  const audienceKey = useMemo(
    () => resolveNoticeAudienceKey(audience, targetSubcircle),
    [audience, targetSubcircle],
  );

  return useMemo(
    () => getDriveFolderNamesForAudience(notices, audienceKey),
    [notices, audienceKey],
  );
}
